import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a818768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-cell" }
const _hoisted_2 = { class: "game-nickname" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Enter your nickname*", -1))
const _hoisted_4 = { class: "inline" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small" }, "*optional", -1))
const _hoisted_6 = { class: "game-result" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Try again ")
const _hoisted_9 = ["width", "height"]
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Score: ")
const _hoisted_12 = { class: "current-score" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SButton = _resolveComponent("SButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["overlay before-game", { enabled: _ctx.playerIsNew }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "Input your nickname",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.player.name) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitName && _ctx.submitName(...args)))
          }, null, 544), [
            [_vModelText, _ctx.player.name]
          ]),
          _createVNode(_component_SButton, {
            class: "bg-blue",
            onClick: _ctx.submitName
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "sign-in-alt" })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _hoisted_5
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["overlay after-game", { enabled: _ctx.gameScore !== null }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, "Your score is: " + _toDisplayString(_ctx.gameScore), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SButton, {
            class: "bg-blue",
            onClick: _ctx.init
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_font_awesome_icon, { icon: "sync" })
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ], 2),
    _createElementVNode("canvas", {
      ref: "canvas",
      width: _ctx.width,
      height: _ctx.height,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args))),
      onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args)))
    }, null, 40, _hoisted_9),
    _createElementVNode("p", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentScore), 1)
    ])
  ]))
}